// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"style_lds-ellipsis__AiuoW","lds-ellipsis1":"style_lds-ellipsis1__IjEyw","lds-ellipsis2":"style_lds-ellipsis2__xzGNi","lds-ellipsis3":"style_lds-ellipsis3__HN6Xn"};